<template>
  <v-card flat tile>

  <v-card-text class="pa-0 body text--primary">
    <slot name="text"></slot>
  </v-card-text>

  <v-card-actions class="pt-0 mt-0">
    <v-spacer />
    <span class="caption text--disabled">
      {{ entry.createdAt | moment("MMM D YYYY, h:mma") }}
    </span>
    <v-btn v-if="entry.uuid" @click="deleteLogEntry" x-small icon class="text--disabled"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
  </v-card-actions>
  <v-dialog v-model="deleting" max-width="800px">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            Delete Log Entry?
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
          <v-btn @click="close" text>Nevermind</v-btn>
        <v-btn @click="deleteTrack" color="error"
          >Yes, Delete it!</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-card>
</template>

<script>
export default {
  props: [ 'entry' ],
  data() {
    return { deleting: false }
  },
  methods: {
    deleteLogEntry() {
      this.deleting = true
    },
      close() {
        this.deleting = false
      },
      reset() {
      },
      deleteTrack() {
        this.$store.dispatch('log/deleteEntry', this.entry)
        this.close()
      }
  },
}
</script>

